import React from "react";

const toSlug = (text) =>
  text
    .toLowerCase() // lowercase
    .trim() // remove leading/trailing spaces
    .replace(/[^a-z0-9]+/g, "-") // replace spaces & non-alphanumerics with '-'
    .replace(/^-+|-+$/g, ""); // remove leading/trailing hyphens

const getProductUrl = (productName, sku, productId) => {
  const name = (productName ?? "").trim();
  const normalizedSku = (sku ?? "").trim().toLowerCase();

  if (!name || !normalizedSku || !productId) return "/products";

  // Match SEO.GenerateProductUrl without changing category/promotion slugs.
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  // Keep existing working links until the backend fixes unsafe SKU segments.
  if (/[/?#\\%]/.test(normalizedSku)) {
    return `/product/${toSlug(name)}/${toSlug(normalizedSku)}/${productId}`;
  }

  if (!slug) return "/products";

  return `/product/${slug}/${normalizedSku}/${productId}`;
};

const toTitleCase = (text) => {
  if (!text) return "";

  const raw =
    typeof text === "string"
      ? text
      : text?.props?.children
      ? text.props.children
      : String(text);

  return raw
    .toLowerCase()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const getProductFilters = (search) => {
  const params = new URLSearchParams(search);
  const category = params.get("category") || "cat-0";
  const categoryMatch = category.match(/^((?:cat|sub)-[1-9]\d*)(?:-.*)?$/i);
  const page = Number(params.get("page") || 1);
  const sort = params.get("sort") || "date_asc";

  return {
    selectedKey: categoryMatch ? categoryMatch[1].toLowerCase() : "cat-0",
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
    search: (params.get("search") || "").trim(),
    sort: ["date_asc", "date_desc", "name_asc", "name_desc"].includes(sort)
      ? sort
      : "date_asc",
  };
};

const getProductsUrl = ({
  selectedKey = "cat-0",
  categoryName = "",
  page = 1,
  search = "",
  sort = "date_asc",
} = {}) => {
  const params = new URLSearchParams();
  if (selectedKey !== "cat-0") {
    const slug = categoryName ? toSlug(categoryName) : "";
    params.set("category", `${selectedKey}${slug ? `-${slug}` : ""}`);
  }
  if (page > 1) params.set("page", page);
  if (search) params.set("search", search);
  if (sort !== "date_asc") params.set("sort", sort);
  const query = params.toString();
  return `/products${query ? `?${query}` : ""}`;
};

export { toSlug, toTitleCase, getProductUrl, getProductFilters, getProductsUrl };
